function _optionalChain(ops) {
  let lastAccessLHS = undefined;
  let value = ops[0];
  let i = 1;
  while (i < ops.length) {
    const op = ops[i];
    const fn = ops[i + 1];
    i += 2;
    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      return undefined;
    }
    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn((...args) => value.call(lastAccessLHS, ...args));
      lastAccessLHS = undefined;
    }
  }
  return value;
}
import {getPosts} from "../../services/posts.ts";
import {formatDateTime} from "../../services/util.ts";
import postsListSheet from "./posts-list.css?polyfill=type-css" ;

import themeSheet from "../../styles/theme.css?polyfill=type-css" ;

export default class PostsListComponent extends HTMLElement {
  #posts = [];
  #max = 0;
  async connectedCallback() {
    if (typeof window === "undefined") {
      return;
    }
    if (!this.shadowRoot) {
      this.attachShadow({
        mode: "open"
      });
    }
    this.#posts = (await getPosts()).reverse();
    this.#max = this.hasAttribute("max") ? parseInt(this.getAttribute("max"), 10) : 0;
    _optionalChain([this, 'optionalAccess', _ => _.shadowRoot, 'optionalAccess', _2 => _2.adoptedStyleSheets, 'access', _3 => _3.push, 'call', _4 => _4(themeSheet, postsListSheet)]);
    this.render();
  }
  render() {
    const maxDisplay = !this.#max ? this.#posts.length : this.#max;
    const maxPosts = this.#posts.slice(0, maxDisplay);
    const html = maxPosts.map(post => {
      const formattedDate = formatDateTime(post.createdTime);
      return `
        <div class="post">
          <div class="post__time">Posted: ${formattedDate}</div>

          <h4 class="post__heading">${post.title}</h4>

          <details class="post__summary">${post.summary}</details>
        </div>
      `;
    }).join("");
        const template = document.createElement('template');
    template.innerHTML = `<div class="as-posts-list">
        <h3 class="as-posts-list__heading">Latest Posts</h3>
        <div class="posts">${html}</div>
      </div>`;
    if (!this.shadowRoot) {
      this.attachShadow({
        mode: 'open'
      });
      this.shadowRoot.appendChild(template.content.cloneNode(true));
    } else {
      this.shadowRoot.innerHTML = template.innerHTML;
    }

  }
}
customElements.define("as-posts-list", PostsListComponent);
